// ========---======== < Exercises-Strings > ========---======== //
export const SET_BODY_PARTS = "SET_BODY_PARTS";
export const SET_EXERCISES = "SET_EXERCISES";
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const SET_EXERCISE_DETAILS = "SET_EXERCISE_DETAILS";
export const SET_EXERCISE_VIDEOS = "SET_EXERCISE_VIDEOS";
